module.exports = __webpack_public_path__ + "img/banner-1.848cda86.jpg";